// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__a_dg0","tooltip":"Tag_tooltip__QW3CE"};